import type { CredentialFieldDefaults } from '../../credential-defaults';

export function resolveCloverCredentialDefaults(): CredentialFieldDefaults {
    return {};
}
